"use client";

import { c as _c } from "react/compiler-runtime";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { useCityPopup } from "../../../../_provider/CityPopupProvider";
import { inhomzEvents } from "../../../../_lib/events";
import { useInhomzTrack } from "../../../../_hooks/useInhomzTrack";
export default function BestMatchesHeader() {
  const $ = _c(8);
  const {
    selectedCity,
    openCityPopup
  } = useCityPopup();
  const track = useInhomzTrack();
  const cityLabel = selectedCity?.label ?? "your location";
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="m3-title-medium text-[--textPrimaryPrimary] md:m3-title-large">Best professional matches</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== openCityPopup || $[2] !== track) {
    t1 = () => {
      track(inhomzEvents.designDetail.CHANGE_CITY_CLICKED);
      openCityPopup({
        changeCity: true,
        redirectOnContinue: false
      });
    };
    $[1] = openCityPopup;
    $[2] = track;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LocationOnOutlinedIcon sx={{
      fontSize: 18
    }} />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== cityLabel || $[6] !== t1) {
    t3 = <header className="flex items-center justify-between px-4 pt-4">{t0}<button type="button" onClick={t1} className="m3-label-medium flex flex-shrink-0 items-center gap-1 text-[--colorPrimaryPrimary]">{t2}{cityLabel}</button></header>;
    $[5] = cityLabel;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}